import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import FormWrapper from '../FormWrapper'; 

const ForgotPasswordForm = ({ switchToLogin }) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setMessage('');

    try {
      const response = await fetch('https://api.neontradepro.com/auth/password-reset/request', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();
      if (response.ok) {
        if (data.id) { 
          setMessage('کد بازیابی به ایمیل شما ارسال شد. به صفحه تایید کد هدایت می‌شوید.');
          localStorage.setItem('resetProcessId', data.id); 
          setEmail('');
          setTimeout(() => {
            navigate('/verify-reset-code'); 
          }, 2000); 
        } else {
          setError('درخواست بازیابی موفق بود، اما ID فرآیند دریافت نشد. لطفا با پشتیبانی تماس بگیرید.');
        }
      } else {
        let errorMessage = 'مشکلی پیش آمد. لطفا دوباره تلاش کنید.';
        if (data.detail) {
          if (typeof data.detail === 'string') {
            errorMessage = data.detail;
          } else if (typeof data.detail === 'object' && data.detail.msg) {
            errorMessage = data.detail.msg;
          } else if (Array.isArray(data.detail) && data.detail.length > 0) {
            errorMessage = data.detail.map(err => err.msg || err.detail || 'خطای ناشناخته').join('، ');
          } else {
            errorMessage = JSON.stringify(data.detail);
          }
        }
        setError(errorMessage);
      }
    } catch (err) {
      setError((err instanceof Error ? err.message : 'خطا در ارتباط با سرور. لطفاً بعداً دوباره تلاش کنید.'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <FormWrapper
      title="بازیابی رمز عبور"
      subtitle="ایمیل خود را وارد کنید تا کد بازیابی برای شما ارسال شود."
      currentStep={1}
      totalSteps={3} 
    >
      <form onSubmit={handleSubmit} autoComplete="off">
        {message && <div className="success-message">{message}</div>}
        {error && <div className="error-message">{error}</div>}

        {!message && ( 
          <div className="input-group">
            <label htmlFor="email">ایمیل</label>
            <input
              type="email"
              id="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="ایمیل خود را وارد کنید"
              required
              disabled={loading}
              autoFocus
            />
          </div>
        )}

        {!message && ( 
          <button type="submit" className="main-btn" disabled={loading} style={{width: '100%', marginTop: '1rem'}}>
            {loading ? 'در حال ارسال...' : 'ارسال کد بازیابی'}
          </button>
        )}
        
        <div className="form-footer">
            <a href="#" onClick={(e) => { e.preventDefault(); switchToLogin(); }} style={{cursor: 'pointer'}}>
              بازگشت به صفحه ورود
            </a>
        </div>
      </form>
    </FormWrapper>
  );
};

export default ForgotPasswordForm;